/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       PlusImage.tsx
 * @author     Christian Ascone
 * @date       10/11/19 2:25 PM
 */

import React from 'react';
import {Image} from "react-native";

export function PlusImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/plus.png')
            }
        />
    );
}